<template>
	<v-alert
			class="alert_"
			color="error"
			dense
			text>
		<span	class="overline"
				v-text="order" />
	</v-alert>
</template>

<script>
	export default {
		name: 'DebuggerOrderAlert',
		props: {
			order: Number
		}
	}
</script>

<style scoped>
	.alert_ {
		margin-bottom: 0;
		padding: 0 8px;
	}
</style>
